module.exports = __webpack_public_path__ + "static/logo-38d9c901d360be6cd928ca7a97480309.svg";